export const routeDataIsEqual = <T>(
  newest: T,
  oldest: T
): boolean => JSON.stringify(newest) === JSON.stringify(oldest);

export default {
  routeDataIsEqual,
};
